import React from 'react';
import { SvgIconProps } from './types';

interface Props extends SvgIconProps {
    children: React.ReactNode;
}

const SvgIcon = ({
    fontSize = 'medium',
    className,
    style,
    children,
    size,
    ...otherProps
}: Props) => {
    const sizeMap = {
        small: '20px',
        medium: '24px',
        large: '32px',
        inherit: 'inherit',
    };

    const iconSize = size || sizeMap[fontSize];

    return (
        <svg
            className={className}
            style={{
                width: iconSize,
                height: iconSize,
                fill: 'currentColor',
                ...style,
            }}
            viewBox="0 0 24 24"
            focusable="false"
            aria-hidden="true"
            {...otherProps}
        >
            {children}
        </svg>
    );
};

export default SvgIcon;
